import axios from 'axios';

export default function startChangeOrder(siteId, orderNumber) {
  const url = `${window.location.origin}/api/ordering/startchangeorder?siteId=${siteId}&orderNumber=${orderNumber}`;

  return axios.put(url);
}
